
export enum CustomsInstructionsForHandling {
  IHaveReceipt = 'IHaveReceipt',
  AllowToOpen = 'AllowToOpen',
  Gift = 'Gift',
  Other = 'Other',
  ReevaluteCustomsFee = 'ReevaluteCustomsFee',
}
